import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';

import Slider from '@appigram/react-rangeslider'
import '@appigram/react-rangeslider/lib/index.css'
import { recordLengthFormatter } from '../../../utils/recordLengthFormatter';
import { highchartsLabelFormatterFromMs } from '../../../utils/dateFormatter';



export const AllProcessedDataSlider = forwardRef((props, ref) => {
  const initialMax = props.maxTimeSec || 0;
  const [sliderValue, setSliderValue] = useState(initialMax);
  const lastSliderValue = useRef(initialMax);
  const maxSliderValue = useRef(initialMax);
  const [sliderMaxValue, setSliderMaxValue] = useState(initialMax);

  useImperativeHandle(ref, () => {
    return {
      setLastProcessedTime(lastProcessedTime) {
        // Only update if the max value has changed
        if (lastProcessedTime !== maxSliderValue.current) {
          setSliderMaxValue(lastProcessedTime);
          maxSliderValue.current = lastProcessedTime;
          //console.log(lastProcessedTime);
        }
      },
      getCurrentSliderTime() {
        return sliderValue;
      },
      isCurrendSliderMaxRight() {
        //console.log(lastSliderValue.current, maxSliderValue.current, lastSliderValue.current >= maxSliderValue.current)
        return lastSliderValue.current >= maxSliderValue.current;
      },
      setSliderValue(newValue) {
        // Only update if the value has actually changed
        if (newValue !== sliderValue && newValue !== lastSliderValue.current) {
          setSliderValue(newValue);
          lastSliderValue.current = newValue;
          if (props.onTimeChangedCallback)
            props.onTimeChangedCallback(newValue);
        }
      }
    };
  }, [sliderValue, props.onTimeChangedCallback]);


  useEffect(() => {    
    //console.log('useEffect: slider');
  }, [sliderMaxValue]);


  const NUMBER_OF_TICKS = 7;

  const getHorizontalLabels = () => {
    let res = {};
    let step = (sliderMaxValue - props.minTimeSec) / NUMBER_OF_TICKS;
    for (let i = 0; i <= NUMBER_OF_TICKS; i++) {
      let time = i * step + props.minTimeSec;
      if (props.timeViewMode === 1 && props.recordStartTime) {
        // Convert to actual time by adding record start time
        const startTimeMs = new Date(props.recordStartTime).getTime();
        const actualTimeMs = startTimeMs + (time * 1000);
        res[time] = highchartsLabelFormatterFromMs(actualTimeMs);
      } else {
        res[time] = recordLengthFormatter(time, true);
      }
    }
    return res;
  }

  const formatValue = value => {
    if (props.timeViewMode === 1 && props.recordStartTime) {
      const startTimeMs = new Date(props.recordStartTime).getTime();
      const actualTimeMs = startTimeMs + (value * 1000);
      return highchartsLabelFormatterFromMs(actualTimeMs);
    }
    return recordLengthFormatter(value, true);
  }

  const onSliderChange = (value) => {
    //if (onTimeChangedCallback)
    //  onTimeChangedCallback(value);
    setSliderValue(value);
  };

  const handleChangeComplete = (event) => {
    lastSliderValue.current = sliderValue;
    if (props.onTimeChangedCallback)
      props.onTimeChangedCallback(sliderValue);
  };

  return (
    <>
      <Slider
        min={props.minTimeSec}
        max={sliderMaxValue}
        value={sliderValue}
        labels={getHorizontalLabels()}
        format={formatValue}
        //onChangeStart={() => { debugger; }}
        onChange={onSliderChange}
        onChangeComplete={handleChangeComplete}
      />
    </>
  )
});